import GroupButtons from "../../../ui/button/groupButtons";
import BaseStep from "./baseStep";

interface IFinanceStep {
  onPrevStep: () => void;
  onNexStep: () => void;
  onChange: (data: boolean, key: "finance") => void;
  data: null | boolean;
  isNextStepDisabled: boolean;
}

const FinanceStep = ({
  onChange,
  onPrevStep,
  onNexStep,
  isNextStepDisabled,
  data,
}: IFinanceStep) => {
  const handleChange = (data: boolean) => {
    onChange(data, "finance");
  };

  return (
    <BaseStep
      prevStep={onPrevStep}
      nextStep={onNexStep}
      isNextStepDisabled={isNextStepDisabled}
      text="Планируете использовать кредит (потребительский, ипотека, займ) для приобретения квартиры?"
    >
      <GroupButtons
        data={[
          {
            onClick: () => handleChange(true),
            label: "Планирую использовать",
            variant: data !== null && data === true ? "dark" : "lightDark",
          },
          {
            onClick: () => handleChange(false),
            label: "Не планирую использовать",
            variant: data !== null && data === false ? "dark" : "lightDark",
          },
        ]}
      />
    </BaseStep>
  );
};

export default FinanceStep;
